import "./Card.css";

import { newElement } from "../Dom";
import Component from "./Component";

export default class Card extends Component {

    private url = "";
    private label = "";

    private dialog!: HTMLDialogElement;

    public setUrl(url: string): this {
        this.url = url;
        return this;
    }

    public setLabel(label: string): this {
        this.label = label;
        return this;
    }

    connectedCallback(): void {
        const image = newElement("img", { id: "cardImage" });
        image.src = this.url;
        image.alt = this.label;

        const label = newElement("p", { id: "cardLabel", text: this.label });

        const closeButton = newElement("button", { id: "cardCloseButton", text: "Close" });
        
        closeButton.type = "button";
        
        closeButton.addEventListener("click", () => this.close());

        const footer = newElement("div", { id: "cardFooter" });
        footer.append(label, closeButton);

        const container = newElement("div", { id: "cardContainer" });
        container.style.width = "min(90vw, 26rem)";
        container.append(image, footer);

        const dialog = newElement("dialog", { id: "cardDialog" });
        dialog.append(container);

        dialog.addEventListener("click", (event) => {
            if (event.target === dialog) {
                this.close();
            }
        });

        dialog.addEventListener("close", () => this.remove());

        this.dialog = dialog;

        
        this.replaceChildren(dialog);

        
        dialog.showModal();
    }

    private close(): void {
        this.dialog.close();
    }
}

customElements.define("card-component", Card);
